var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4542_2257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4542_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4539 12.0036L14.5269 16.0767C14.6654 16.2151 14.7362 16.3892 14.7394 16.5988C14.7427 16.8084 14.6718 16.9856 14.5269 17.1305C14.3821 17.2754 14.2064 17.3478 14 17.3478C13.7936 17.3478 13.618 17.2754 13.4731 17.1305L8.97892 12.6362C8.88532 12.5427 8.81929 12.4439 8.78084 12.3401C8.74238 12.2363 8.72314 12.1241 8.72314 12.0036C8.72314 11.8831 8.74238 11.7709 8.78084 11.667C8.81929 11.5632 8.88532 11.4645 8.97892 11.3709L13.4731 6.87667C13.6116 6.7382 13.7856 6.66737 13.9952 6.66417C14.2048 6.66095 14.3821 6.73178 14.5269 6.87667C14.6718 7.02153 14.7443 7.19717 14.7443 7.40357C14.7443 7.60997 14.6718 7.7856 14.5269 7.93047L10.4539 12.0036Z",
    fill: "#35353A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.519bfd12f84c4890acf8ed82a82a8e7f.svg";
export { ForwardRef as ReactComponent };